export default __webpack_public_path__ + "static/media/q9_step2_3.f58e8a5f.png";